import "./card.scss";

import CardHero from "../card-hero/Index";
import CardInfo from "../card-info/Index";
import CardPresentation from "../card-presentation/Index";

import WorkButton from "../../work-button/Index";

const Card = () => {

  return (
    <div className="work-card">
      <CardHero />
      <CardInfo />
      <CardPresentation />
      <WorkButton />
    </div>
  );
};

export default Card;
